<template>
  <div
    ref="parallax"
    class="parallax__outer"
  >
    <div
      class="parallax__inner"
      data-depth="0.2">
      <img
        src="/images/gesture-photos/04-unm-campus.jpg"
        class="parallax__image parallax__image-top"
        alt=""
      >
    </div>
    <div
      class="parallax__inner"
      data-depth="0.4">
      <img
        src="/images/gesture-photos/03-unm-building.jpg"
        class="parallax__image parallax__image-right"
        alt=""
      >
    </div>
    <div
      class="parallax__inner"
      data-depth="0.1">
      <img
        src="/images/gesture-photos/06-unm-student.jpg"
        class="parallax__image parallax__image-bottom"
        alt=""
      >
    </div>
    <div
      class="parallax__inner"
      data-depth="0.6">
      <img
        src="/images/gesture-photos/02-unm-cactus.jpg"
        class="parallax__image parallax__image-left"
        alt=""
      >
    </div>
  </div>
</template>

<script>
  import Parallax from 'parallax-js';

  export default {
    name: 'TheParallax',
    mounted() {
      // eslint-disable-next-line no-new
      new Parallax(this.$refs.parallax);
    },
  };
</script>

<style lang="scss">
.parallax__outer {
  @include z-index(parallax);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.parallax__inner {
  width: 100%;
  height: 100%;
}

.parallax__image {
  position: absolute;
  object-fit: cover;
}

.parallax__image-top {
  top: 13%;
  right: 0;
  left: auto;
  width: 31%;
  height: 8%;

  @include breakpoint(large) {
    top: -10%;
    left: 41%;
    width: 19%;
    height: 18%;
  }
}

.parallax__image-right {
  display: none;

  @include breakpoint(large) {
    top: 47%;
    right: -8%;
    width: 13%;
    height: 41%;
    display: block;
  }
}

.parallax__image-bottom {
  left: 39%;
  bottom: -10%;
  width: 47%;
  height: 14.6%;

  @include breakpoint(large) {
    left: 20%;
    bottom: -10%;
    width: 22%;
    height: 22%;
  }
}

.parallax__image-left {
  top: 52%;
  left: -8%;
  width: 11%;
  height: 28%;

  @include breakpoint(large) {
    top: 31%;
    left: -10%;
    width: 17%;
    height: 37%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheParallax.vue